const gql = (template: TemplateStringsArray) => template.join('');

export const issueLinkTypesQuery = gql`
  query IssueLinkTypesQuery {
    jiraSettings {
      issueLinkTypes {
        id
        name
        inward
        outward
      }
    }
  }
`;
